import { REVIEW_TOKEN_RE } from "@anota/shared/limits";

/**
 * Enlace de revisión: el cliente llega con `?anota=rv_…`. Se guarda en este navegador (para el resto de
 * páginas y visitas) y se quita de la barra de direcciones, para que no se comparta sin querer al copiar
 * la URL. Con el proyecto en "solo con enlace", sin él el widget no aparece.
 */

const storageKey = (projectKey: string) => `anota:review:${projectKey}`;

export function reviewToken(projectKey: string): string | undefined {
  try {
    const url = new URL(location.href);
    const fromUrl = url.searchParams.get("anota");
    if (fromUrl && REVIEW_TOKEN_RE.test(fromUrl)) {
      localStorage.setItem(storageKey(projectKey), fromUrl);
      url.searchParams.delete("anota");
      history.replaceState(history.state, "", `${url.pathname}${url.search}${url.hash}`);
      return fromUrl;
    }
    const saved = localStorage.getItem(storageKey(projectKey));
    return saved && REVIEW_TOKEN_RE.test(saved) ? saved : undefined;
  } catch {
    // Sin almacenamiento (modo privado estricto): vale solo mientras esté en la URL.
    return undefined;
  }
}

/** Un enlace revocado o caducado se olvida: así no se vuelve a probar en cada página. */
export function forgetReviewToken(projectKey: string): void {
  try {
    localStorage.removeItem(storageKey(projectKey));
  } catch {
    // Nada que borrar.
  }
}
